// Mirror discount-summary toggle (OPEN only for the target widget)
(function () {
  var TARGET_ID = '189826';                     // your widget id
  var WIDGET_SEL = '#rebuy-widget-' + TARGET_ID;

  function roots() {
    var out = [document];
    document.querySelectorAll('rebuy-cart,[data-rebuy-component="cart"]').forEach(function (host) {
      if (host.shadowRoot) out.push(host.shadowRoot);
    });
    return out;
  }

  function wireOne(widget){
    if (!widget || widget.__rbUpsellWired) return;

    var wrap  = widget.querySelector('[data-upsell]');
    var btn   = wrap && wrap.querySelector('[data-upsell-toggle]');
    var panel = wrap && wrap.querySelector('[data-upsell-details]');
    if (!wrap || !btn || !panel) return;

    // Default OPEN only for this widget
    wrap.classList.add('is-expanded');
    btn.setAttribute('aria-expanded','true');
    panel.setAttribute('aria-hidden','false');

    btn.addEventListener('click', function(e){
      e.stopPropagation();
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      wrap.classList.toggle('is-expanded', !expanded);
      panel.setAttribute('aria-hidden', String(expanded));
    });

    widget.__rbUpsellWired = true;
  }

  function wireAll(scope){
    roots().forEach(function(root){
      var node = root.querySelector(WIDGET_SEL);
      if (node) wireOne(node);
    });
  }

  if (document.readyState !== 'loading') wireAll();
  else document.addEventListener('DOMContentLoaded', wireAll);

  document.addEventListener('rebuy:render', function(e){ wireAll(e && e.detail && e.detail.el); });
  document.addEventListener('rebuy:cart-change', function(){ wireAll(); });

  try {
    new MutationObserver(function(){ wireAll(); })
      .observe(document.documentElement, { childList: true, subtree: true });
  } catch(e){}
})();

// ---------------------------------------------
// OKENDO STORE ID
// ---------------------------------------------
const OKENDO_STORE_ID = "25150091-e498-4e04-824d-27b1e754a304";


// ---------------------------------------------
// Fetch Okendo review data
// ---------------------------------------------
async function getOkendoReviewData(productId) {
  const url = `https://api.okendo.io/v1/stores/${OKENDO_STORE_ID}/products/shopify-${productId}/review_aggregate`;

  try {
    const res = await fetch(url);
    if (!res.ok) return null;

    const json = await res.json();
    const agg = json.reviewAggregate;
    if (!agg) return null;

    const count = agg.reviewCount || 0;
    const total = agg.reviewRatingValuesTotal || 0;
    const average = count > 0 ? total / count : 0;

    return { average, count };

  } catch (err) {
    console.error("Okendo error:", err);
    return null;
  }
}


// ---------------------------------------------
// Render stars
// ---------------------------------------------
function renderOkendoStars(el, avg, count) {
  if (!el) return;
  if (!count || count === 0) {
    el.innerHTML = "";
    return;
  }

  const rounded = Math.round(avg * 10) / 10;
  const fillPercent = (rounded / 5) * 100;

  el.innerHTML = `
    <span class="rebuy-star-rating">
      <span class="rebuy-star-rating-background"></span>
      <span class="rebuy-star-rating-foreground" style="width:${fillPercent}%"></span>
    </span>

    <span class="rebuy-review-count">
      <span class="rebuy-review-count-parenthesis">(</span>
      <span class="rebuy-review-count-number">${count}</span>
      <span class="rebuy-review-count-label"> Reviews</span>
      <span class="rebuy-review-count-parenthesis">)</span>
    </span>
  `;
}


// ---------------------------------------------
// On Smart Cart SHOW
// ---------------------------------------------
document.addEventListener("rebuy:smartcart.show", async function () {
  console.log("🌟 Okendo handler fired!");

  const scopes = [document];
  document.querySelectorAll("rebuy-cart,[data-rebuy-component='cart']").forEach(host => {
    if (host.shadowRoot) scopes.push(host.shadowRoot);
  });

  scopes.forEach(async (root) => {
    // FIXED SELECTOR HERE
    const nodes = root.querySelectorAll(".rebuy-product-review[data-product-id]");
    console.log("🌟 Found star nodes inside scope:", nodes.length);

    for (const node of nodes) {
      const pid = node.getAttribute("data-product-id");
      if (!pid) continue;

      const data = await getOkendoReviewData(pid);
      if (!data) continue;

      renderOkendoStars(node, data.average, data.count);
    }
  });
});
